var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 107,
    viewBox: "0 0 75 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_1105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6787 106.81H0.183594V0H56.1846L74.6787 18.2563V106.81Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1836 18.494H74.6776L56.1836 0V18.494Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 83.8435H74.8614V106.81H0V83.8435Z",
    fill: "#BC9850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2227 88.8328H26.1836C28.7328 88.8328 30.462 90.2676 30.462 92.5399C30.462 95.1566 28.4995 96.3407 26.1226 96.3407H23.8176V100.82H21.2227V88.8328ZM23.8176 94.2844H25.7976C26.997 94.2844 27.8453 93.8243 27.8453 92.5987C27.8453 91.3732 26.9512 90.9 25.8522 90.9H23.8176V94.2844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7656 88.8328H37.5216C41.0106 88.8328 43.2981 91.1333 43.2981 94.6791C43.2981 98.1681 41.0826 100.826 37.4104 100.826H32.7656V88.8328ZM35.3584 98.7307H37.3035C39.6019 98.7307 40.6203 97.0211 40.6203 94.6856C40.6203 92.723 39.6674 90.9284 37.3188 90.9284H35.3562L35.3584 98.7307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9102 88.8328H54.2816V90.9589H48.4419V93.8962H53.9131V96.0223H48.4419V100.82H45.9102V88.8328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0586 48.3098H59.0172V52.235H16.0586V48.3098Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8438 57.6865H59.0205V61.6117H15.8438V57.6865Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8438 67.0632H43.4332V70.9884H15.8438V67.0632Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 29.5759H59.0201V42.9345H15.7344V29.5759Z",
    fill: "#C9C9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_1105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.8614,
    height: 106.81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.e6e09c1d787a4476d7d59904c4477d9f.svg";
export { ForwardRef as ReactComponent };